import { styled } from '@mui/material'
import { TTheme } from '@/core/theme'

export const TopSectionWrapper = styled('div')`
    margin-bottom: 12px;
`
export const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    height: 32px;
`

export const IntegrationTitle = styled('div')`
    display: flex;
    gap: 10px;
    align-items: center;
`

export const DescriptionWrapper = styled('div')`
    margin-bottom: 24px;
`
export const IntegrationWrapper = styled('div')<{ theme?: TTheme }>`
    border-radius: 12px;
    background-color: ${({ theme }: { theme: TTheme }) =>
        theme.colors.semantic.backgroundSecondary};
    transition: background 0.2s;
    padding: 24px;
    margin-bottom: 24px;
    width: 100%;
`
